import { UserId } from '@beelday/common'

export class BeeldayMediaStream extends MediaStream {
	screenShareTrackId?: string

	constructor(tracks: MediaStreamTrack[]) {
		super(tracks)
	}
}

export type RemoteUserStream = {
	feedId: string
	userId: UserId
	stream: BeeldayMediaStream
	janusId: string
}

export type VideoUser = {
	stream?: BeeldayMediaStream
	userId: UserId
	userName?: string
}

export type LocalMediaStream = {
	stream: MediaStream
}

export type SceneVideoUser = VideoUser & {
	spotlight: boolean
	presenter: boolean
	muted: boolean
	videoMuted?: boolean
	isSelfView: boolean
}

export type VideoStreamMedia = {
	stream: MediaStream
	muted: boolean
}
